module.exports = __webpack_public_path__ + "img/img_event_banner_02.de87c108.jpg";